<template>
  <div v-if="!isMobile" id="page">
    <nav class="nav">
      <v-app-bar app height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData" class="mr-2">
          <v-card class="pa-2" slot="input" style="outline:1px solid grey;">
            <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="blue" class="ma-1 white--text" @click="printPage" fab small v-bind="attrs" v-on="on">
              <v-icon dark>
                mdi-printer
              </v-icon>
            </v-btn>
          </template>
          <span>Print / Save</span>
        </v-tooltip>
      </v-app-bar>
    </nav>

    <v-row style="margin-top: -2rem; display:none;" class="report-title">
      <v-container>
        <h2 justify="center" align="center">Overview</h2>
        <h3 justify="center" align="center">Report for {{ formatDate2($store.state.dateTime1) }} - {{ formatDate2($store.state.dateTime2) }}</h3>
        <p justify="center" align="center" style="color:grey; font-size: 14px;">Generated at: {{ dateNow() }}</p>
      </v-container>
    </v-row>

    <v-container grid-list-md>
      <v-layout row>
        <div style="width:100%; display: flex; justify-content:space-between;" class="row-1">
          <v-card style="flex-basis:49%;">
            <v-btn-toggle v-model="boardItem" dense mandatory dark shaped @change="updateBoard">
              <v-btn v-for="item in boardName" style="font-size:11px;" :key="item._id" :value="item.boardName">
                {{ item.boardName }}
              </v-btn>
            </v-btn-toggle>

            <v-card-title style="font-size:12px">Current Usage By Phase</v-card-title>
            <v-card-text justify="center" align="center">
              <span v-if="currentPhase.length == 0">No Data</span>
              <apexchart height="350" :options="kwhP1Chart" :series="kwhP1Series" v-else></apexchart>
            </v-card-text>
          </v-card>
          <v-card style="flex-basis:49%;">
            <v-card-text>
              <div v-if="location.length == 0">
                <h4 style="font-size:12px;color:black;">Current Usage By Location</h4>
                <br />
                <p>No Data</p>
              </div>
              <apexchart height="280" :options="ampP2Chart" :series="ampP2Series" v-else></apexchart>
            </v-card-text>

            <v-card-text>
              <div v-if="loadType.length == 0">
                <h4 style="font-size:12px;color:black;">Current Usage By Appliances</h4>
                <br />
                <p>No Data</p>
              </div>
              <apexchart height="280" :options="ampP3Chart" :series="ampP3Series" v-else></apexchart>
            </v-card-text>
          </v-card>
        </div>

        <div class="pagebreak"></div>

        <v-row class="table-row tableDiv">
          <v-container>
            <v-card>
              <v-card-title style="font-size:12px"> <v-icon color="orange">mdi-lightning-bolt</v-icon>Top 3 Total MCB Current Usage </v-card-title>
              <v-simple-table id="mytable" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="font-size:11px">
                        #
                      </th>
                      <th class="text-left" style="font-size:11px">
                        DB Name
                      </th>
                      <th class="text-left" style="font-size:11px">
                        MCB Label
                      </th>
                      <th class="text-left" style="font-size:11px">
                        Current Used
                      </th>
                      <th class="text-left" style="font-size:11px">
                        Location
                      </th>
                      <th class="text-left" style="font-size:11px">
                        Load Types
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="font-size:11px">1</td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[0]._id.boardName == ''">Unknown</div>
                        <div v-else>{{ totalBoard[0]._id.boardName }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[0]._id.ryb.label == ''">Unknown</div>
                        <div v-else>{{ totalBoard[0]._id.ryb.label }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[0].value == 0">Unknown</div>
                        <div v-else>{{ totalBoard[0].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[0].location == ''">Unknown</div>
                        <div v-else>{{ totalBoard[0].location[0].location }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[0]._id.loadType == ''">Unknown</div>
                        <div v-else>{{ totalBoard[0]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:11px">2</td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[1]._id.boardName == ''">Unknown</div>
                        <div v-else>{{ totalBoard[1]._id.boardName }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[1]._id.ryb.label == ''">Unknown</div>
                        <div v-else>{{ totalBoard[1]._id.ryb.label }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[1].value == 0">Unknown</div>
                        <div v-else>{{ totalBoard[1].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[1].location == ''">Unknown</div>
                        <div v-else>{{ totalBoard[1].location[0].location }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[1]._id.loadType == ''">Unknown</div>
                        <div v-else>{{ totalBoard[1]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:11px">3</td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[2]._id.boardName == ''">Unknown</div>
                        <div v-else>{{ totalBoard[2]._id.boardName }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[2]._id.ryb.label == ''">Unknown</div>
                        <div v-else>{{ totalBoard[2]._id.ryb.label }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[2].value == 0">Unknown</div>
                        <div v-else>{{ totalBoard[2].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[2].location == ''">Unknown</div>
                        <div v-else>{{ totalBoard[2].location[0].location }}</div>
                      </td>
                      <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="totalBoard[2]._id.loadType == ''">Unknown</div>
                        <div v-else>{{ totalBoard[2]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-container>

          <v-container class="peakMcbPrint peakMcbDiv">
            <v-card class="peak-usage">
              <v-card-title style="font-size:12px"> <v-icon color="orange">mdi-lightning-bolt</v-icon>Top 3 Peak MCB Current Usage </v-card-title>
              <v-simple-table id="mytable" dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="font-size:11px">
                        #
                      </th>
                      <th class="text-left" style="font-size:11px">
                        DB Name
                      </th>
                      <th class="text-left" style="font-size:11px">
                        MCB Label
                      </th>
                      <th class="text-left" style="font-size:11px">
                        Current Used
                      </th>
                      <th class="text-left" style="font-size:11px">
                        Location
                      </th>
                      <th class="text-left" style="font-size:11px">
                        Load Types
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="font-size:11px">1</td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[0]._id.boardName == ''">Unknown</div>
                        <div v-else>{{ maxBoard[0]._id.boardName }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[0]._id.ryb.label == ''">Unknown</div>
                        <div v-else>{{ maxBoard[0]._id.ryb.label }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[0].value == 0">Unknown</div>
                        <div v-else>{{ maxBoard[0].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[0].location == ''">Unknown</div>
                        <div v-else>{{ maxBoard[0].location[0].location }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[0]._id.loadType == ''">Unknown</div>
                        <div v-else>{{ maxBoard[0]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:11px">2</td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[1]._id.boardName == ''">Unknown</div>
                        <div v-else>{{ maxBoard[1]._id.boardName }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[1]._id.ryb.label == ''">Unknown</div>
                        <div v-else>{{ maxBoard[1]._id.ryb.label }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[1].value == 0">Unknown</div>
                        <div v-else>{{ maxBoard[1].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[1].location == ''">Unknown</div>
                        <div v-else>{{ maxBoard[1].location[0].location }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[1]._id.loadType == ''">Unknown</div>
                        <div v-else>{{ maxBoard[1]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:11px">3</td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[2]._id.boardName == ''">Unknown</div>
                        <div v-else>{{ maxBoard[2]._id.boardName }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[2]._id.ryb.label == ''">Unknown</div>
                        <div v-else>{{ maxBoard[2]._id.ryb.label }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[2].value == 0">Unknown</div>
                        <div v-else>{{ maxBoard[2].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[2].location == ''">Unknown</div>
                        <div v-else>{{ maxBoard[2].location[0].location }}</div>
                      </td>
                      <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                      <td style="font-size:11px" v-else>
                        <div v-if="maxBoard[2]._id.loadType == ''">Unknown</div>
                        <div v-else>{{ maxBoard[2]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-container>
        </v-row>

        <!-- <div class="pagebreak"></div> -->
        <div class="pagebreak2"></div>

        <v-col class="aqRecentlyPrint" cols="12" style="padding:0; margin:0; margin-top: 1rem; margin-bottom: 1rem;">
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="cyan">mdi-weather-windy</v-icon>Air Quality Monitoring(Recently) </v-card-title>
            <v-simple-table id="mytable" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      CO2 Level
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Temperature
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Humidity
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Last Updated
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="airQualityNow.length == 0">
                    <td style="font-size:11px">No Data</td>
                    <td style="font-size:11px">No Data</td>
                    <td style="font-size:11px">No Data</td>
                    <td style="font-size:11px">No Data</td>
                    <td style="font-size:11px">No Data</td>
                  </tr>
                  <tr v-for="item in airQualityNow" :key="item._id" v-else>
                    <td style="font-size:11px">{{ item.location[0].location }}</td>
                    <td style="font-size:11px">{{ item.co2 }} ppm</td>
                    <td style="font-size:11px">{{ item.temp }} °C</td>
                    <td style="font-size:11px">{{ item.humid }} %RH</td>
                    <td v-if="lastUpdate(item.timestamp).includes('ago') == true" style="font-size:11px">
                      <v-icon v-if="lastOnline(item.timestamp) < 360" color="green">mdi-circle</v-icon>
                      <v-icon v-else>mdi-circle</v-icon>{{ lastUpdate(item.timestamp) }}
                    </td>
                    <td v-else style="font-size:11px">
                      <v-icon v-if="lastOnline(item.timestamp) < 360" color="green">mdi-circle</v-icon>
                      <v-icon v-else>mdi-circle</v-icon>{{ lastUpdate(item.timestamp).substring(2) }} ago
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br />
        </v-col>

        <v-col cols="12" class="aqPeakDiv">
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="cyan">mdi-weather-windy</v-icon>Air Quality Monitoring(Peak Value) </v-card-title>
            <v-simple-table id="mytable" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      CO2 Level
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Temperature
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Humidity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="airQuality.length == 0">
                    <td style="font-size:11px">No Data</td>
                    <td style="font-size:11px">No Data</td>
                    <td style="font-size:11px">No Data</td>
                    <td style="font-size:11px">No Data</td>
                  </tr>
                  <tr v-for="item in airQuality" v-else :key="item._id">
                    <td style="font-size:11px">{{ item.location[0].location }}</td>
                    <td style="font-size:11px">{{ item.co2 }} ppm</td>
                    <td style="font-size:11px">{{ item.temp }} °C</td>
                    <td style="font-size:11px">{{ item.humid }} %RH</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-layout>
    </v-container>

    <div class="pagebreak2"></div>

    <div class="waterDiv">
      <v-container style="display:flex; align-items:flex-start; gap:5px;" class="row-2">
        <div style="flex-basis:70%;" class="waterUsageDiv">
          <v-card style="flex-basis:100%;" class="water-usage">
            <v-card-title style="font-size:12px"> <v-icon color="blue">mdi-water</v-icon>Top 3 Water Usage </v-card-title>
            <v-simple-table id="mytable" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      #
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Sensor Label
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Current Used
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Outlet Types
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-size:11px">1</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[0]._id.location }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[0]._id.waterSensor }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ (top3WaterFlow[0].value / 1000).toFixed(0) }}<span style="font-size:9px;color:black;"> m3</span></td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[0]._id.outletType.map(({ item }) => item).join(" + ") }}</td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">2</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[1]._id.location }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[1]._id.waterSensor }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ (top3WaterFlow[1].value / 1000).toFixed(0) }}<span style="font-size:9px;color:black;"> m3</span></td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[1]._id.outletType.map(({ item }) => item).join(" + ") }}</td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">3</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[2]._id.location }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[2]._id.waterSensor }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ (top3WaterFlow[2].value / 1000).toFixed(0) }}<span style="font-size:9px;color:black;"> m3</span></td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[2]._id.outletType.map(({ item }) => item).join(" + ") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </div>

        <div style="display: flex; align-items:flex-start; gap: 5px; flex-basis:100%;" class="row-3">
          <v-card style="flex-basis:100%;" class="water-usage">
            <v-card-title style="font-size:12px;"
              ><span>Water Flow Monitoring</span>
              <v-icon color="blue">mdi-water-pump</v-icon>
            </v-card-title>

            <v-sheet color="cyan" class="mx-auto text-center">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Total Volume
                </div>
                <div style="font-size:18px;color:black;" v-if="monthWaterFlow.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else>{{ (monthWaterFlow[0].total / 1000).toFixed(0) }}<span style="font-size:15px;color:black;"> m3</span></div>
              </v-card-text>
            </v-sheet>
          </v-card>

          <v-card style="flex-basis:100%;" height="400" class="water-usage rainWaterHarvesting">
            <v-card-title style="font-size:12px"> <v-icon color="blue">mdi-cup-water</v-icon>Rain Water Harvesting Monitoring </v-card-title>

            <v-simple-table id="tankTable">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Last Updated
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      <div v-if="lastUpdate(waterTank[0].timestamp).includes('ago') == true">
                        <v-icon v-if="lastOnline(waterTank[0].timestamp) < 360" color="green">mdi-circle</v-icon>
                        <v-icon v-else>mdi-circle</v-icon>{{ lastUpdate(waterTank[0].timestamp) }}
                      </div>
                      <div v-else>
                        <v-icon v-if="lastOnline(waterTank[0].timestamp) < 360" color="green">mdi-circle</v-icon>
                        <v-icon v-else>mdi-circle</v-icon>{{ lastUpdate(waterTank[0].timestamp).substring(2) }} ago
                      </div>
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Water Tank Level Sensor
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      {{ waterTank[0].tags.waterTankConsole }}
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Tank Water Level Console
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      {{ waterTank[0].tags.waterTankSensor }}
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Rain Water Harvesting Location
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      {{ waterTank[0].tags.locationRemarks }}
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Water Level Currently
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>{{ waterConv[0] }}mm</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Rainwater Consumed
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>{{ Math.abs(negativeSum) }}mm</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Rainwater Collected
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>{{ positiveSum }}mm</th>
                  </tr>
                </thead>
              </template>
            </v-simple-table>
          </v-card>
        </div>
      </v-container>
    </div>
  </div>

  <div v-else>
    <div class="mt-5 pa-1" justify="center" align="center">
      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: 5px;">{{ formatDate(values1) }} - </span> <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate(values2) }}</span>
            </v-card>
          </v-md-date-range-picker>
        </v-card>
      </div>
    </div>

    <v-container>
      <v-layout row wrap>
        <v-col>
          <v-card>
            <v-btn-toggle dense mandatory dark shaped>
              <v-btn v-for="item in boardName" style="font-size:11px;" :key="item._id">
                {{ item.boardName }}
              </v-btn>
            </v-btn-toggle>
            <v-card-title style="font-size:12px">Current Usage By Phase</v-card-title>
            <v-card-text justify="center" align="center" v-if="loadingRYB">
              <v-progress-circular indeterminate :size="40" :width="5"></v-progress-circular>
            </v-card-text>
            <v-card-text v-else>
              <span v-if="currentPhase.length == 0">No Data</span>
              <apexchart height="150" :options="kwhP1Chart" :series="kwhP1Series" v-else></apexchart>
            </v-card-text>
          </v-card>

          <br />
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="orange">mdi-lightning-bolt</v-icon>Top 3 Total MCB Current Usage </v-card-title>
            <v-skeleton-loader v-bind="attrs" type="table-thead, table-row, table-row" v-if="loadingCurrent"></v-skeleton-loader>
            <v-simple-table id="mytable" dense v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      #
                    </th>
                    <th class="text-left" style="font-size:11px">
                      DB Name
                    </th>
                    <th class="text-left" style="font-size:11px">
                      MCB Label
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Current Used
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Load Types
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-size:11px">1</td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[0]._id.boardName == ''">Unknown</div>
                      <div v-else>{{ totalBoard[0]._id.boardName }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[0]._id.ryb.label == ''">Unknown</div>
                      <div v-else>{{ totalBoard[0]._id.ryb.label }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[0].value == 0">Unknown</div>
                      <div v-else>{{ totalBoard[0].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[0].location == ''">Unknown</div>
                      <div v-else>{{ totalBoard[0].location[0].location }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[0]._id.loadType == ''">Unknown</div>
                      <div v-else>{{ totalBoard[0]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">2</td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[1]._id.boardName == ''">Unknown</div>
                      <div v-else>{{ totalBoard[1]._id.boardName }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[1]._id.ryb.label == ''">Unknown</div>
                      <div v-else>{{ totalBoard[1]._id.ryb.label }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[1].value == 0">Unknown</div>
                      <div v-else>{{ totalBoard[1].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[1].location == ''">Unknown</div>
                      <div v-else>{{ totalBoard[1].location[0].location }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[1]._id.loadType == ''">Unknown</div>
                      <div v-else>{{ totalBoard[1]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">3</td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[2]._id.boardName == ''">Unknown</div>
                      <div v-else>{{ totalBoard[2]._id.boardName }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[2]._id.ryb.label == ''">Unknown</div>
                      <div v-else>{{ totalBoard[2]._id.ryb.label }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[2].value == 0">Unknown</div>
                      <div v-else>{{ totalBoard[2].value.toFixed(2) }}<span style="font-size: 9px;">A</span></div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[2].location == ''">Unknown</div>
                      <div v-else>{{ totalBoard[2].location[0].location }}</div>
                    </td>
                    <td style="font-size:11px" v-if="totalBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="totalBoard[2]._id.loadType == ''">Unknown</div>
                      <div v-else>{{ totalBoard[2]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>

        <v-col>
          <v-card>
            <v-card-text v-if="loadingRYB">
              <h4 style="font-size:12px;color:black;">Current Usage By Location</h4>
              <v-progress-circular indeterminate :size="40" :width="5"></v-progress-circular>
            </v-card-text>
            <v-card-text v-else>
              <div v-if="location.length == 0">
                <h4 style="font-size:12px;color:black;">Current Usage By Location</h4>
                <br />
                <p>No Data</p>
              </div>
              <apexchart width="350" height="200" :options="ampP2Chart" :series="ampP2Series" v-else></apexchart>
            </v-card-text>
            <v-card-text v-if="loadingRYB">
              <h4 style="font-size:12px;color:black;">Current Usage By Appliances</h4>
              <v-progress-circular indeterminate :size="40" :width="5"></v-progress-circular>
            </v-card-text>
            <v-card-text v-else>
              <div v-if="loadType.length == 0">
                <h4 style="font-size:12px;color:black;">Current Usage By Appliances</h4>
                <br />
                <p>No Data</p>
              </div>
              <apexchart width="320" height="200" :options="ampP3Chart" :series="ampP3Series" v-else></apexchart>
            </v-card-text>
          </v-card>
          <br />
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="orange">mdi-lightning-bolt</v-icon>Top 3 Peak MCB Current Usage </v-card-title>
            <v-skeleton-loader v-bind="attrs" type="table-thead, table-row, table-row" v-if="loadingCurrent"></v-skeleton-loader>

            <v-simple-table id="mytable" dense v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      #
                    </th>
                    <th class="text-left" style="font-size:11px">
                      DB Name
                    </th>
                    <th class="text-left" style="font-size:11px">
                      MCB Label
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Current Used
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Load Types
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-size:11px">1</td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[0]._id.boardName == ''">Unknown</div>
                      <div v-else>{{ maxBoard[0]._id.boardName }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[0]._id.ryb.label == ''">Unknown</div>
                      <div v-else>{{ maxBoard[0]._id.ryb.label }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[0].value == 0">Unknown</div>
                      <div v-else>{{ maxBoard[0].value }}<span style="font-size: 9px;">A</span></div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[0].location == ''">Unknown</div>
                      <div v-else>{{ maxBoard[0].location[0].location }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[0]._id.loadType == ''">Unknown</div>
                      <div v-else>{{ maxBoard[0]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">2</td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[1]._id.boardName == ''">Unknown</div>
                      <div v-else>{{ maxBoard[1]._id.boardName }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[1]._id.ryb.label == ''">Unknown</div>
                      <div v-else>{{ maxBoard[1]._id.ryb.label }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[1].value == 0">Unknown</div>
                      <div v-else>{{ maxBoard[1].value }}<span style="font-size: 9px;">A</span></div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[1].location == ''">Unknown</div>
                      <div v-else>{{ maxBoard[1].location[0].location }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[1]._id.loadType == ''">Unknown</div>
                      <div v-else>{{ maxBoard[1]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">3</td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[2]._id.boardName == ''">Unknown</div>
                      <div v-else>{{ maxBoard[2]._id.boardName }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[2]._id.ryb.label == ''">Unknown</div>
                      <div v-else>{{ maxBoard[2]._id.ryb.label }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[2].value == 0">Unknown</div>
                      <div v-else>{{ maxBoard[2].value }}<span style="font-size: 9px;">A</span></div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[2].location == ''">Unknown</div>
                      <div v-else>{{ maxBoard[2].location[0].location }}</div>
                    </td>
                    <td style="font-size:11px" v-if="maxBoard.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>
                      <div v-if="maxBoard[2]._id.loadType == ''">Unknown</div>
                      <div v-else>{{ maxBoard[2]._id.loadType.map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity).join(" ") }}</div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>

        <v-col>
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="cyan">mdi-weather-windy</v-icon>Air Quality Monitoring(Recently) </v-card-title>
            <v-skeleton-loader v-bind="attrs" type="table-thead, table-row, table-row" v-if="loadingAQR"></v-skeleton-loader>
            <v-simple-table id="mytable" dense v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      CO2 Level
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Temperature
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Humidity
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Last Updated
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="airQualityNow.length == 0">
                    <td style="font-size:11px;">No Data</td>
                    <td style="font-size:11px;">No Data</td>
                    <td style="font-size:11px;">No Data</td>
                    <td style="font-size:11px;">No Data</td>
                    <td style="font-size:11px;">No Data</td>
                  </tr>
                  <tr v-for="item in airQualityNow" :key="item._id" v-else>
                    <td style="font-size:11px">{{ item.location[0].location }}</td>
                    <td style="font-size:11px">{{ item.co2 }} ppm</td>
                    <td style="font-size:11px">{{ item.temp }} °C</td>
                    <td style="font-size:11px">{{ item.humid }} %RH</td>
                    <td v-if="lastUpdate(item.timestamp).includes('ago') == true" style="font-size:11px">
                      <v-icon v-if="lastOnline(item.timestamp) < 360" color="green">mdi-circle-medium</v-icon>
                      <v-icon v-else>mdi-circle-medium</v-icon>{{ lastUpdate(item.timestamp) }}
                    </td>
                    <td v-else style="font-size:11px">
                      <v-icon v-if="lastOnline(item.timestamp) < 360" color="green">mdi-circle-medium</v-icon>
                      <v-icon v-else>mdi-circle-medium</v-icon>{{ lastUpdate(item.timestamp).substring(2) }} ago
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
          <br />
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="cyan">mdi-weather-windy</v-icon>Air Quality Monitoring(Peak Value) </v-card-title>
            <v-skeleton-loader v-bind="attrs" type="table-thead, table-row, table-row" v-if="loadingAQR"></v-skeleton-loader>

            <v-simple-table id="mytable" dense v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      CO2 Level
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Temperature
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Ambient Humidity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="airQuality.length == 0">
                    <td style="font-size:11px;">No Data</td>
                    <td style="font-size:11px;">No Data</td>
                    <td style="font-size:11px;">No Data</td>
                    <td style="font-size:11px;">No Data</td>
                  </tr>
                  <tr v-for="item in airQuality" :key="item._id" v-else>
                    <td style="font-size:11px">{{ item.location[0].location }}</td>
                    <td style="font-size:11px">{{ item.co2 }} ppm</td>
                    <td style="font-size:11px">{{ item.temp }} °C</td>
                    <td style="font-size:11px">{{ item.humid }} %RH</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-layout>
    </v-container>

    <v-container>
      <v-layout row wrap>
        <v-col cols="12">
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="blue">mdi-water</v-icon>Top 3 Water Usage </v-card-title>
            <v-skeleton-loader v-bind="attrs" type="table-thead, table-row, table-row" v-if="loadingWU"></v-skeleton-loader>

            <v-simple-table id="mytable" dense v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      #
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Location
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Sensor Label
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Current Used
                    </th>
                    <th class="text-left" style="font-size:11px">
                      Outlet Types
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-size:11px">1</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[0]._id.location }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[0]._id.waterSensor }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ (top3WaterFlow[0].value / 1000).toFixed(0) }}<span style="font-size:9px;color:black;"> m3</span></td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[0]._id.outletType.map(({ item }) => item).join(" + ") }}</td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">2</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[1]._id.location }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[1]._id.waterSensor }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ (top3WaterFlow[1].value / 1000).toFixed(0) }}<span style="font-size:9px;color:black;"> m3</span></td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[1]._id.outletType.map(({ item }) => item).join(" + ") }}</td>
                  </tr>
                  <tr>
                    <td style="font-size:11px">3</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[2]._id.location }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[2]._id.waterSensor }}</td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ (top3WaterFlow[2].value / 1000).toFixed(0) }}<span style="font-size:9px;color:black;"> m3</span></td>
                    <td style="font-size:11px" v-if="top3WaterFlow.length == 0">No Data</td>
                    <td style="font-size:11px" v-else>{{ top3WaterFlow[2]._id.outletType.map(({ item }) => item).join(" + ") }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title style="font-size:12px;">
              <v-icon color="blue">mdi-water-pump</v-icon>
              Water Flow Monitoring
            </v-card-title>

            <v-sheet color="cyan" class="mx-auto text-center" v-if="loadingWF">
              <v-skeleton-loader v-bind="attrs" type="list-item"></v-skeleton-loader>
            </v-sheet>

            <v-sheet color="cyan" class="mx-auto text-center" v-else>
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Total Volume
                </div>
                <div style="font-size:18px;color:black;" v-if="monthWaterFlow.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else>{{ (monthWaterFlow[0].total / 1000).toFixed(0) }}<span style="font-size:15px;color:black;"> m3</span></div>
              </v-card-text>
            </v-sheet>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title style="font-size:12px"> <v-icon color="blue">mdi-cup-water</v-icon>Rain Water Harvesting Monitoring </v-card-title>
            <v-skeleton-loader v-bind="attrs" type="table-tbody" width="350" v-if="loadingWF"></v-skeleton-loader>

            <v-simple-table id="tankTable" v-else>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Last Updated
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      <div v-if="lastUpdate(waterTank[0].timestamp).includes('ago') == true">
                        <v-icon v-if="lastOnline(waterTank[0].timestamp) < 360" color="green">mdi-circle</v-icon>
                        <v-icon v-else>mdi-circle</v-icon>{{ lastUpdate(waterTank[0].timestamp) }}
                      </div>
                      <div v-else>
                        <v-icon v-if="lastOnline(waterTank[0].timestamp) < 360" color="green">mdi-circle</v-icon>
                        <v-icon v-else>mdi-circle</v-icon>{{ lastUpdate(waterTank[0].timestamp).substring(2) }} ago
                      </div>
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Water Tank Level Sensor
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      {{ waterTank[0].tags.waterTankConsole }}
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Tank Water Level Console
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      {{ waterTank[0].tags.waterTankSensor }}
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Rain Water Harvesting Location
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>
                      {{ waterTank[0].tags.locationRemarks }}
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Water Level Currently
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>{{ waterConv[0] }}mm</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Rainwater Consumed
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>{{ Math.abs(negativeSum) }}mm</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th class="text-left" style="font-size:11px">
                      Rainwater Collected
                    </th>
                    <th class="text-left" style="font-size:11px" v-if="waterTank.length == 0">
                      No Data
                    </th>
                    <th class="text-left" style="font-size:11px" v-else>{{ positiveSum }}mm</th>
                  </tr>
                </thead>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: true,
          href: "/",
        },
      ],
      // values1: moment()
      //   .clone()
      //   .startOf("week"),
      // values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment()],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment()],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment()],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [
            moment()
              .clone()
              .startOf("week"),
            moment()
              .clone()
              .endOf("week"),
          ],
        },
        {
          label: "Last Week",
          range: [
            moment()
              .subtract(1, "weeks")
              .startOf("week"),
            moment()
              .subtract(1, "weeks")
              .endOf("week"),
          ],
        },
        {
          label: "This Month",
          range: [moment().startOf("month"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month"), moment().subtract(1, "month")],
        },
      ],
      isMobile: true,
      loading: true,
      loadingRYB: true,
      loadingCurrent: true,
      loadingAQR: true,
      loadingWU: true,
      loadingWF: true,
      currentPhase: [],
      boardName: [],
      boardItem: [],
      totalBoard: [],
      maxBoard: [],
      location: [],
      locationTankItem: [],
      locationTank: [],
      loadType: [],
      airQuality: [],
      airQualityNow: [],
      monthWaterFlow: [],
      top3WaterFlow: [],
      waterTank: [],
      waterLevel: [],
      waterSub: [],
      waterPercent: [],
      waterVol: [],

      kwhP1Chart: {
        chart: {
          width: "100%",
          type: "bar",
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        colors: ["#ff0303", "#f6fa16", "#0339ff"],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ["R", "Y", "B"],
        },
        legend: {
          show: true,
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return val.toFixed(1) + "kW";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val.toFixed(2) + " kWh";
            },
          },
        },
      },
      kwhP1Series: [
        {
          data: [],
        },
      ],

      ampP2Chart: {
        fill: {
          colors: ["#33B2DF", "#546E7A", "#D4526E", "#13D8AA", "#A5978B", "#4ECDC4", "#4CAF50", "#81D4FA", "#FF9800", "#FD6A6A"],
        },
        chart: {
          width: "100%",
          type: "pie",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        labels: [],
        tooltip: {
          enabled: true,
          fillSeriesColor: true,
          y: {
            formatter: function(val) {
              return val.toFixed(2) + "A";
            },
          },
        },
        colors: ["#33B2DF", "#546E7A", "#D4526E", "#13D8AA", "#A5978B", "#4ECDC4", "#4CAF50", "#81D4FA", "#FF9800", "#FD6A6A"],
        legend: {
          position: "right",
          markers: {
            fillColors: ["#33B2DF", "#546E7A", "#D4526E", "#13D8AA", "#A5978B", "#4ECDC4", "#4CAF50", "#81D4FA", "#FF9800", "#FD6A6A"],
          },
        },
        title: {
          text: "Current Usage By Location",
          align: "left",
          floating: false,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
          },
        },
      },
      ampP2Series: [],

      ampP3Chart: {
        fill: {
          colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", "#3F51B5"],
        },
        chart: {
          width: "100%",
          type: "pie",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        labels: [],
        tooltip: {
          enabled: true,
          fillSeriesColor: true,
          y: {
            formatter: function(val) {
              return val.toFixed(2) + "A";
            },
          },
        },
        colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", "#3F51B5"],
        legend: {
          position: "right",
          markers: {
            fillColors: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", "#3F51B5"],
          },
        },
        title: {
          text: "Current Usage By Appliances",
          align: "left",
          floating: false,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
          },
        },
      },
      ampP3Series: [],
    }),
    mounted() {
      this.loadsLocation();
      this.loadsLocationWaterTank();
      this.loadsLoadType();
      this.loadsBoardName();
      this.loadsMaxBoard();
      this.loadsTotalBoard();
      this.loadsCurrentPhase();
      this.loadsMaxWaterFlow();
      this.loadsMaxWaterFlowTop3();
      this.loadsCO2();
      this.loadsCO2Now();
      this.loadsWaterTank();
      this.onResize();
      this.intervalFetchData();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
      dateNow() {
        return moment().format("ddd DD MMM YYYY, h:mm:ss a");
      },
      printPage() {
        window.print();
      },
      lastUpdate(value) {
        return moment().from(moment(value));
      },
      lastOnline(value) {
        return moment().diff(moment(value), "minutes");
      },
      intervalFetchData: function() {
        this.dateNow();
        setInterval(() => {
          this.loadsMaxBoard(), this.loadsTotalBoard(), this.loadsCurrentPhase(), this.loadsMaxWaterFlow(), this.loadsMaxWaterFlowTop3(), this.loadsCO2(), this.loadsCO2Now(), this.loadsWaterTank();
        }, 60000);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      formatDate2(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsCurrentPhase: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/cms/overview/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.currentPhase = res.data;
            this.kw1 = res.data.map((kw) => kw.fields.p_phase1);
            this.kw2 = res.data.map((kw) => kw.fields.p_phase2);
            this.kw3 = res.data.map((kw) => kw.fields.p_phase3);

            this.kwhP1Series = [
              {
                name: "Total",
                data: [this.kw1.slice(-1)[0] - this.kw1[0], this.kw2.slice(-1)[0] - this.kw2[0], this.kw3.slice(-1)[0] - this.kw3[0]],
              },
            ];
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsLocation: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/count-location/" + this.$store.state.dateTime1.toDate() + "-" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.location = res.data;
            for (let i = 0; i < res.data.length; i++) {
              this.ampP2Series.push(res.data[i].value);
              this.ampP2Chart.labels.push(res.data[i].result[0].location);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingRYB = false));
      },
      loadsBoardName: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/single-phase";
        axios
          .get(apiURL)
          .then((res) => {
            this.boardName = res.data;
            this.boardItem = this.boardName[1].boardName;
            this.loadsCurrentPhase();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsLoadType: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/count-load-type/" + this.$store.state.dateTime1.toDate() + "-" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.loadType = res.data;
            for (let i = 0; i < res.data.length; i++) {
              this.ampP3Series.push(res.data[i].value);
              this.ampP3Chart.labels.push(res.data[i]._id);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsTotalBoard: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/total/" + this.$store.state.dateTime1.toDate() + "-" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.totalBoard = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingCurrent = false));
      },
      loadsMaxBoard: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/max/" + this.$store.state.dateTime1.toDate() + "-" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.maxBoard = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsMaxWaterFlow: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-flow/max/" + this.$store.state.dateTime1.toDate() + "-" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.monthWaterFlow = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingWF = false));
      },
      loadsMaxWaterFlowTop3: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-flow/top3/" + this.$store.state.dateTime1.toDate() + "-" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.top3WaterFlow = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingWU = false));
      },
      loadsCO2: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/air-quality/aq/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.airQuality = res.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsCO2Now: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/air-quality/aq/recent/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.airQualityNow = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loadingAQR = false));
      },
      loadsWaterTank: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-tank/" + this.locationTankItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.waterTank = res.data;
            this.waterLevel = res.data.map((water) => water.fields.water_level);
            this.waterConv = this.waterLevel.map((x) => 2057 - x);
            this.waterSub = this.waterConv.slice(1).map((v, i) => v - this.waterConv[i]);
            this.waterPercent = this.waterConv.map((x) => (x / 2057) * 100);
            this.waterVol = this.waterConv.map((x) => (x * 1220 * 3660) / 1000000);
            this.positive = this.waterSub.filter((posNumber) => posNumber >= 0);
            this.negative = this.waterSub.filter((negNumber) => negNumber < 0);
            this.positiveSum = this.positive.reduce((sumSoFar, current) => sumSoFar + current, 0);
            this.negativeSum = this.negative.reduce((sumSoFar, current) => sumSoFar + current, 0);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsLocationWaterTank: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/location-water-tank";
        axios
          .get(apiURL)
          .then((res) => {
            this.locationTank = res.data;
            this.locationTankItem = this.locationTank[0]._id;
            this.loadsWaterTank();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsLocation();
        this.loadsCurrentPhase();
        this.loadsCO2();
        this.loadsCO2Now();
        this.ampP2Series.splice(values, this.location.length);
        this.ampP2Chart.labels.splice(values, this.location.length);
        this.loadsLoadType();
        this.ampP3Series.splice(values, this.loadType.length);
        this.ampP3Chart.labels.splice(values, this.loadType.length);
        this.loadsTotalBoard();
        this.loadsMaxBoard();
        this.loadsMaxWaterFlow();
        this.loadsMaxWaterFlowTop3();
        this.loadsWaterTank();
        this.loading = true;
        this.loadingRYB = true;
        this.loadingCurrent = true;
        this.loadingAQR = true;
        this.loadingWU = true;
        this.loadingWF = true;
      },
      updateBoard() {
        this.loadsCurrentPhase();
        this.loading = true;
        this.loadingRYB = true;
        this.loadingCurrent = true;
        this.loadingAQR = true;
        this.loadingWU = true;
        this.loadingWF = true;
      },
      updateLocationTank() {
        this.loadsWaterTank();
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
  };
</script>
<style>
  #mytable table thead tr th {
    background: rgba(138, 131, 131, 0.348);
  }

  #tankTable table thead tr th:nth-child(1) {
    background: rgba(0, 0, 255, 0.708);
    color: rgb(255, 255, 255);
  }

  #tankTable table thead tr th {
    border: 2px groove;
  }

  .tableDiv {
    margin-top: 1rem;
  }

  .peakMcbDiv {
    margin-top: 0.2rem !important;
  }

  .aqPeakDiv {
    margin-top: -0.8rem;
    padding: 0;
  }

  .waterDiv {
    margin-top: 0.5rem;
  }

  /* @page {
    margin: 0.25in;
    padding: 0;
  } */

  @page {
    size: auto;
    size: A4;
    margin: 0mm;
    margin: 1cm 0;
    /* margin: 0.25in; */
  }

  @media print {
    html,
    body {
      width: 100%;
      /* height: 200%; */
      overflow-y: hidden;
      margin: 0 auto;
      padding: 0;
    }
    #sidebar,
    .nav {
      display: none;
    }

    #page {
      margin-left: -252px;
    }

    .tableDiv {
      margin-top: 0;
    }

    .peakMcbDiv {
      margin-top: -2rem !important;
    }

    .aqPeakDiv {
      margin-top: 0 !important;
    }

    .waterDiv {
      margin-top: 0;
    }

    .waterUsageDiv {
      margin-top: 3rem;
      margin-bottom: 1rem;
    }

    .rainWaterHarvesting {
      margin-top: 1rem;
    }

    .row-1,
    .row-2,
    .row-3 {
      flex-direction: column;
      justify-content: space-between;
    }
    .row-1 > * {
      margin-bottom: 1rem;
    }

    .row-2 > *,
    .row-3 > * {
      width: 100%;
    }

    .water-usage {
      margin-bottom: 1rem;
    }

    .report-title {
      display: block !important;
    }

    .table-row {
      margin-top: 6%;
    }

    .pagebreak {
      page-break-after: always;
    }
    .pagebreak2 {
      page-break-before: always;
    }

    .peakMcbPrint {
      margin-top: -2rem;
    }

    .aqRecentlyPrint {
      margin-top: 7rem !important;
    }
  }
</style>
